import { v4 as uuidv4 } from 'uuid';
export class ChangePasswordModel {
    constructor() {
        this.id = uuidv4();
        this.oldPassword = '';
        this.newPassword = '';
        this.newConfirmPassword = '';
    }
}
export default class SecurityUser extends ChangePasswordModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
